/**
 * Editable self-service profile fields for `/account/information`.
 * Align name/phone with API `ALLOWED_ACCOUNT_UPDATE_KEYS`. Email changes use the
 * `account/email-change/*` verification flow (not `PUT account/update`).
 */
export const PROFILE_FIELD_IDS = [
  "email",
  "firstName",
  "lastName",
  "fullName",
  "phone",
];

/**
 * @param {Record<string, unknown>|null|undefined} user
 * @returns {Record<string, string>}
 */
export function pickProfileFields(user) {
  if (!user || typeof user !== "object") {
    return PROFILE_FIELD_IDS.reduce((acc, key) => {
      acc[key] = "";
      return acc;
    }, {});
  }
  return PROFILE_FIELD_IDS.reduce((acc, key) => {
    if (key === "email") {
      const v = user.pendingEmail || user.email;
      acc[key] = v == null ? "" : String(v);
      return acc;
    }
    const v = user[key];
    acc[key] = v == null ? "" : String(v);
    return acc;
  }, {});
}

/**
 * @param {Record<string, string>} baseline
 * @param {Record<string, string>} current
 * @returns {boolean}
 */
export function isProfileDirty(baseline, current) {
  return PROFILE_FIELD_IDS.some((key) => {
    const a = baseline[key] ?? "";
    const b = current[key] ?? "";
    return a !== b;
  });
}

/**
 * @param {Record<string, string>} baseline
 * @param {Record<string, string>} current
 * @returns {boolean}
 */
export function isEmailChanged(baseline, current) {
  const a = (baseline.email ?? "").trim().toLowerCase();
  const b = (current.email ?? "").trim().toLowerCase();
  return a !== b;
}
